import './App.css';

import MainPage from "../src/pages/MainPage"
import Details from "../src/pages/Details/detail"
import { BrowserRouter, Route, Routes } from "react-router-dom";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes>
              <Route exact path="/" element={<MainPage />} />
              <Route path="/detail" element={<Details />} />
          </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
